import { render, staticRenderFns } from "./OrganizationBranchWorkShift.vue?vue&type=template&id=0995c45f"
import script from "./OrganizationBranchWorkShift.vue?vue&type=script&lang=js"
export * from "./OrganizationBranchWorkShift.vue?vue&type=script&lang=js"
import style0 from "./OrganizationBranchWorkShift.vue?vue&type=style&index=0&id=0995c45f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports